/** @internal */
export const mix = (from: number, to: number, q: number) => from + (to - from) * q;
